import $ from 'jquery';
import {
  Swiper, EffectFade, Navigation, Lazy, Pagination,
} from 'swiper';
import { Fancybox } from '@fancyapps/ui';
import { getBreakpoints } from '../utils/utils';

const swipers = [];
const btns = '.tile-accommodation__tab';
const accommodationContainer = '.tile-accommodation';
const swiperContainerClass = '.tile-accommodation__slider';
const accommodationContent = '.tile-accommodation__content';
const accomodationSelect = '.tile-accommodation__select';
const navigationContainer = '.tile-accommodation__navigation, .room-type__navigation';

$(accommodationContainer).find(accommodationContent).not(':first-of-type').hide();

$(btns).on('click', function () {
  const currentTab = $(this).data('tab');
  const parentEl = $(this).closest(accommodationContainer);
  parentEl.find(btns).removeClass('active');
  $(this).addClass('active');
  parentEl.find(accommodationContent).hide().removeClass('showed');
  parentEl.find(`.tile-accommodation__content[data-content="${currentTab}"]`).show().addClass('showed');
});

$(accomodationSelect).on('change', function () {
  const parentEl = $(this).closest(accommodationContainer);
  const selected = $(this).find(':selected').data('tab');
  parentEl.find(accommodationContent).hide().removeClass('showed');
  parentEl.find(`.tile-accommodation__content[data-content="${selected}"]`).show().addClass('showed');
});

function refreshTabindex() {
  const $container = $('.swiper-slide a, .swiper-slide .c-expander__button-label');
  $container.attr('tabindex', -1);
  setTimeout(() => {
    const $containerActive = $('.swiper-slide-active a, .swiper-slide-active .c-expander__button-label');
    $containerActive.attr('tabindex', 0);
  }, 0);
}

function initSwiperContentSlider($slider) {
  if ($slider.find('.swiper-slide').length === 0) return;
  const currentSlide = $slider.attr('current-slide') ? $slider.attr('current-slide') : 0;
  const swiper = new Swiper($slider[0], {
    effect: 'slide',
    lazy: {
      loadPrevNext: false,
    },
    spaceBetween: 0,
    threshold: 15,
    loop: $slider.find('.swiper-slide').length > 1,
    autoHeight: true,
    initialSlide: currentSlide,
    navigation: {
      nextEl: $slider.find('.tile-accommodation__arrow--next')[0],
      prevEl: $slider.find('.tile-accommodation__arrow--prev')[0],
    },
    pagination: {
      clickable: true,
      el: '.tile-accommodation__pagination',
      renderBullet: (index, className) => `<button class="${className}" aria-label="Choose slide to display"></button>`,
    },
    modules: [EffectFade, Navigation, Lazy, Pagination],
    on: {
      init() {
        refreshTabindex();
      },
      slideChange() {
        refreshTabindex();
      },
    },
  });

  swipers.push(swiper);
}

function refreshPagination($slider) {
  if ($(window).width() < getBreakpoints().lg) {
    const pagination = $slider.find('.content-slider__nav-container .content-slider__pagination');
    const nav = $slider.find('.content-slider__nav');

    pagination.removeClass('content-slider__pagination--gray');
    nav.removeClass('position-absolute');
    pagination.addClass('content-slider__pagination--white position-absolute w-100 text-center');
    $slider.prepend(pagination);
  } else {
    const paginationContainer = $slider.find('.content-slider__nav-container');
    const pagination = $slider.find('.content-slider__pagination');
    pagination.removeClass('content-slider__pagination--white position-absolute w-100 text-center');
    paginationContainer.prepend(pagination);
  }
}

function init() {
  const $boxes = $(swiperContainerClass);
  $boxes.each(function () {
    const $slider = $(this);
    refreshPagination($slider);
    initSwiperContentSlider($slider);
  });
}

function syncSwiperWithFancyboxSlide(fancybox) {
  const triggerElement = fancybox.getSlide()?.triggerEl;
  const sliderElement = triggerElement?.closest(swiperContainerClass);
  const swiper = sliderElement?.swiper;

  if (!triggerElement || !swiper || !sliderElement) {
    return;
  }

  const $links = $(sliderElement).find('.swiper-slide').not('.swiper-slide-duplicate').find('a[data-fancybox]');
  const slideIndex = $links.index(triggerElement);
  swiper.slideToLoop(slideIndex > -1 ? slideIndex : 0);
}

function openRoomTypeFancybox(triggerElement, isKeyboard = false) {
  if (!isKeyboard && triggerElement) {
    triggerElement.classList.add('hide-focus-outline');
    const removeFocusClass = (e) => {
      if (e.key === 'Tab') {
        triggerElement.classList.remove('hide-focus-outline');
        document.removeEventListener('keydown', removeFocusClass);
      }
    };
    document.addEventListener('keydown', removeFocusClass);
  }
  const $content = $(triggerElement).closest(accommodationContent);
  const $links = $content.find('a[data-fancybox]');
  const startIndex = $links.index(triggerElement);

  const slides = $links.map((_, link) => ({
    src: link.getAttribute('data-src') || link.getAttribute('href'),
    caption: link.getAttribute('data-caption') || '',
    triggerEl: link,
  })).get();

  if (!slides.length) {
    return;
  }

  Fancybox.show(slides, {
    startIndex: startIndex > -1 ? startIndex : 0,
    idle: false,
    caption: false,
    Thumbs: false,
    Toolbar: {
      display: {
        left: [],
        middle: [],
        right: ['close'],
      },
    },
    placeFocusBack: true,
    on: {
      closing: syncSwiperWithFancyboxSlide,
    },
  });
}

$(document).on('click', 'a[data-fancybox^="accommodation-"]', (event) => {
  event.preventDefault();
  const isKeyboard = event.originalEvent && event.originalEvent.detail === 0;
  openRoomTypeFancybox(event.currentTarget, isKeyboard);
});

$(document).on('click', navigationContainer, function (event) {
  const $target = $(event.target);
  const isControlClick = $target.closest(
    '.tile-accommodation__arrow-btn, .tile-accommodation__pagination .swiper-pagination-bullet',
  ).length;

  if (isControlClick) {
    return;
  }

  const $slider = $(this).closest(swiperContainerClass);
  const $activeLink = $slider.find('.swiper-slide-active .tile-accommodation__image-link').first();

  if ($activeLink.length) {
    const isKeyboard = event.originalEvent && event.originalEvent.detail === 0;
    openRoomTypeFancybox($activeLink[0], isKeyboard);
  }
});

window.addEventListener('resize', () => {
  // eslint-disable-next-line no-restricted-globals
  if (screen.width !== $(window).width()) {
    swipers.forEach((swiper) => {
      swiper.destroy();
      // eslint-disable-next-line no-param-reassign
      swiper = null;
    });

    init();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  init();
});
export default true;
